import React from "react";

// const base_url = `http://localhost:3001/api/v1/mmp/`;
const base_url = `https://api.mymusicpublisher.com/api/v1/mmp/`;
export const utils = {
  base_url,
};
